import React, { useEffect, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import PlatformAdminDashboard from '../../pages/platform-admin-dashboard';
import SchoolAdminDashboard from '../../pages/school-admin-dashboard';
import { api } from '../../lib/api';
import Button from '../ui/Button';

export default function AdminDashboardGate() {
  const navigate = useNavigate();
  const { me, isLoading, refresh, signOut } = useAuth();

  const [showPwdModal, setShowPwdModal] = useState(false);
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [pwdLoading, setPwdLoading] = useState(false);
  const [pwdError, setPwdError] = useState('');

  if (isLoading) return null;
  if (!me) return <Navigate to="/authentication-portal" replace />;
  if ((me.role || '').toLowerCase() !== 'admin') return <Navigate to="/" replace />;

  const isPlatform = Boolean((me as any).is_platform_admin);

  useEffect(() => {
    // Only enforce this for school admins (director account).
    if (!isPlatform && me?.must_change_password) setShowPwdModal(true);
  }, [isPlatform, me?.must_change_password]);

  const validatePassword = (pwd: string) => /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/.test(pwd);

  const handleChangePassword = async () => {
    if (newPassword !== confirmPassword) {
      setPwdError('Parolele nu coincid.');
      return;
    }
    if (!validatePassword(newPassword)) {
      setPwdError('Parola trebuie sa contina litere mari/mici, cifre si simboluri.');
      return;
    }
    setPwdLoading(true);
    setPwdError('');
    try {
      await api.put('/api/users/me/password/initial', {
        new_password: newPassword,
        confirm_password: confirmPassword,
      });
      await refresh();
      alert('Parola a fost schimbata. Vei fi delogat.');
      signOut();
      navigate('/authentication-portal');
    } catch (err: any) {
      setPwdError(err?.response?.data?.detail || 'Eroare la schimbarea parolei.');
    } finally {
      setPwdLoading(false);
    }
  };

  if (!isPlatform && showPwdModal) {
    return (
      <div className="fixed inset-0 z-[1100] flex items-center justify-center bg-black/50 p-4">
        <div className="w-full max-w-md bg-card border border-border rounded-lg shadow-lg p-6">
          <h2 className="text-lg font-semibold text-foreground mb-2">Schimbă parola inițială</h2>
          <p className="text-sm text-muted-foreground mb-4">
            Pentru securitate, te rugăm să îți setezi o parolă nouă.
          </p>

          {pwdError && <div className="mb-3 text-sm text-error">{pwdError}</div>}

          <div className="space-y-3">
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="w-full px-3 py-2 text-sm border border-border rounded-md bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary"
              placeholder="Parola nouă"
              autoComplete="new-password"
            />
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="w-full px-3 py-2 text-sm border border-border rounded-md bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary"
              placeholder="Confirmă parola"
              autoComplete="new-password"
            />
          </div>

          <div className="mt-4 flex justify-end gap-2">
            <Button
              variant="outline"
              onClick={() => {
                signOut();
                navigate('/authentication-portal');
              }}
            >
              Delogare
            </Button>
            <Button variant="default" onClick={handleChangePassword} loading={pwdLoading}>
              Salvează
            </Button>
          </div>
        </div>
      </div>
    );
  }

  if (isPlatform) return <PlatformAdminDashboard />;
  return <SchoolAdminDashboard />;
}
